module.exports = __webpack_public_path__ + "static/media/arrow.9c12a59b.svg";